import Mitt from "mitt";

const eventHub = new Mitt();

export default eventHub;
